import * as React from 'react';
import { SelectBox } from 'sos-common/js/components/FormControls/SelectBox';
import { Icon } from 'sos-common/js/components/Icon/icon';

export class TitleWithSelectBoxData extends React.Component<any, any> {

    public render() {
        const { title, showTopComponent, children, className, countSwedish, countEnglish, options, errorMessage } = this.props;
        //console.log(this.props)


        return (<div className={`m-b-4 ${className}`}>
            {showTopComponent && children}
            {options && <>
                <label className={`${title.cssClass}`}>{title.text}</label>
                <div className={`m-b-4 container ${className}__children`}>
                    <div className="row m-b-1">
                        <SelectBox
                            // additionalAttributes={{ 'aria-labelledby': 'todo' }} todo
                            className="max25"
                            disableDefaultOption={true}
                            options={options[0].data}
                            value={countSwedish.value}
                            onChange={e => this.props.onChange({ ...e, value: Number(e.value) }, this.props.id)}
                            fieldName={showTopComponent ? options[0].fieldName : options[0].fieldNameTillFolkbokforing}
                        />
                        <div className={`${className}__children__child`}>{options[0].text}</div>
                    </div>
                    <div className="row">
                        <SelectBox
                            // additionalAttributes={{ 'aria-labelledby': 'todo' }} todo
                            className="max25"
                            disableDefaultOption={true}
                            options={options[1].data}
                            value={countEnglish.value}
                            onChange={e => this.props.onChange({ ...e, value: Number(e.value) }, this.props.id)}
                            fieldName={showTopComponent ? options[1].fieldName : options[1].fieldNameTillFolkbokforing}
                        />
                        <div className={`${className}__children__child`}>{options[1].text}</div>
                    </div>
                    {true && <>
                        <span className="error-message" role="alert">
                            {(countSwedish.errorMessage !== '' || countEnglish.errorMessage !== '') &&
                                <>
                                    <Icon iconType='Summering_inte_OK25px25px' />
                                    <span>{errorMessage}</span>
                                </>
                            }
                        </span>
                    </>}

                </div>
            </>}
        </div>);
    }
}